import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  handleImageChange,
  uploadAdditionalPhoto,
  getCroppedImg,
  compressImage,
  deleteImage,
} from "../../utils/imageUtils";
import { useTheme, useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  Grid,
  Card,
  Button,
  CardMedia,
  Tabs,
  Tab,
  Typography,
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Switch,
  Tooltip,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { sweetRed } from "../../theme/Colors";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonIcon from "@mui/icons-material/Person";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import PinDropIcon from "@mui/icons-material/PinDrop";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SecurityIcon from "@mui/icons-material/Security";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import PreferenceAccordion from "./PreferenceAccordion";
import ProfileDetails from "../../api_calls/ProfileDetailsApi";
import ProfilesApi from "../../api_calls/ApiServices";
import { useAuth } from "../../context/AuthContext";
import { useWebSocket } from "../../context/WebSocketContext";
import PhotoLightbox from "../Components/PhotoLightbox";

import preferenceCategories from "constants/preferenceCategories";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ValidatePhotoApi from "../../api_calls/PhotoValidationApi";
import AboutMeApi from "../../api_calls/AboutMeApi";
import { showSuccess, showError } from "../../utils/toastUtils";

import MyPhotosTab from "./Tabs/MyPhotosTab";
import AdditionalInfoTab from "./Tabs/AdditionalInfoTab";
import SettingsTab from "./Tabs/SettingsTab";

import Configs from "../../utils/Configs";
import AppConstants from "../../constants/appConstants";

const MyProfile = () => {
  //   const [activeTab, setActiveTab] = useState(0);
  const { userId, section } = useParams();
  console.log("PARAM CHECK:", { userId, section });

  const [activeTab, setActiveTab] = useState(section === "settings" ? 2 : 0);

  const { user, refreshProfileChecklist, notifyProfilePhotoChanged } = useAuth();
  const { sendMessage, isConnected } = useWebSocket();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDeactivateDialog, setOpenDeactivateDialog] = useState(false);

  const [aboutMe, setAboutMe] = useState("");
  const wordCount = aboutMe.trim().split(/\s+/).filter(Boolean).length;

  const [image, setImage] = useState(null); // Holds selected image
  const [crop, setCrop] = useState(); // Resizable/movable crop box, percent units (react-image-crop)
  const [uploadStatus, setUploadStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [overlayOtherOpen, setOverlayOtherOpen] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false); // To toggle the overlay visibility

  const [uploading, setUploading] = useState(false);

  const history = useHistory();
  const fileInputRef = useRef();
  const fileOtherInputRef = useRef();
  const cropImgRef = useRef(null);

  const [selectedPrefs, setSelectedPrefs] = useState({});
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [hidePhotos, setHidePhotos] = useState(false);
  const [showPhotosToAnonymous, setShowPhotosToAnonymous] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDeactivateClick = () => {
    setOpenDeactivateDialog(true);
  };

  const handleDeactivateConfirm = () => {
    console.log("⚠️ Account deactivation confirmed");
    setOpenDeactivateDialog(false);
    // TODO: Add actual deactivation logic here
  };

  const handleDeactivateCancel = () => {
    setOpenDeactivateDialog(false);
  };

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);
  const handleDeleteConfirmed = () => {
    console.log("🗑️ Account deletion confirmed.");
    setOpenDialog(false);
  };

  const handleAnonymousPhotoToggle = (event) => {
    const newValue = event.target.checked;
    setShowPhotosToAnonymous(newValue);

    const preferenceUpdate = {
      user_id: user?.user_id,
      tag: "privacy_update",
      payload: {
        show_to_anonymous: newValue ? "yes" : "no",
      },
    };

    if (isConnected) {
      sendMessage(preferenceUpdate);
    } else {
      console.warn("WebSocket not connected. Message not sent.");
    }
  };

  const handleHidePhotosToggle = (event) => {
    const isChecked = event.target.checked;
    setHidePhotos(isChecked);

    const privacyUpdate = {
      user_id: user?.user_id,
      tag: "privacy_update",
      payload: {
        hide_photos: isChecked ? "yes" : "no",
      },
    };

    if (isConnected) {
      sendMessage(privacyUpdate);
    } else {
      console.warn("WebSocket not connected. Message not sent.");
    }
  };

  const handleRegionChange = (e) => {
    const regionId = e.target.value;
    setSelectedRegion(regionId);
    console.log("Selected Country:", selectedCountry);
    console.log("Selected Region:", regionId);

    const preferenceUpdate = {
      user_id: user?.user_id,
      tag: "location_update",
      payload: {
        country: selectedCountry,
        region: regionId,
      },
    };

    if (isConnected) {
      sendMessage(preferenceUpdate);
    } else {
      console.warn("WebSocket not connected. Message not sent.");
    }
  };

  useEffect(() => {
    if (section === "settings") {
      setActiveTab(2);
    }
  }, [section]);

  // Fetch countries on mount
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countryData = await ProfilesApi.fetchCountries();
        const mapped = countryData.map(({ name, isoCode, callingCode }) => ({
          isoCode,
          name,
          value: callingCode,
        }));
        setCountries(mapped);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    loadCountries();
  }, []);

  // Fetch regions when country changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (!selectedCountry) {
        setRegions([]);
        setSelectedRegion("");
        return;
      }

      try {
        const areas = await ProfilesApi.fetchCountryAreas(selectedCountry);
        setRegions(areas);
      } catch (error) {
        console.error("Failed to fetch regions:", error);
        setRegions([]);
      }
    };

    fetchRegions();
  }, [selectedCountry]);

  const handleSaveAboutMe = async () => {
    const success = await AboutMeApi.updateAboutMe(userId, aboutMe);

    if (success) {
      setProfile((prevProfile) => ({ ...prevProfile, aboutMe }));
      showSuccess("About Me saved successfully!", 8000);
      refreshProfileChecklist();
    } else {
      showError("Failed to save About Me. Please try again.", 8000);
    }
  };

  const triggerOtherFileInput = () => {
    fileOtherInputRef.current.click();
  };

  // A gallery photo was made the profile photo: update the card here and
  // tell the sidebar avatar to refresh, all without a page reload.
  const handleProfilePhotoChanged = (profilePicUrl) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      profile_image: `${Configs.baseUrl}${profilePicUrl}`,
      has_profile_photo: true,
    }));
    notifyProfilePhotoChanged();
    refreshProfileChecklist();
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  // Handle file input change (image selection)
  const handleFileOtherInputChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Store image preview for cropping
        setCrop(undefined); // Reset; set once the image loads and we know its size
        setOverlayOtherOpen(true); // Show the overlay and cropper
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle file input change (image selection)
  const handleFileInputChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Store image preview for cropping
        setCrop(undefined); // Reset; set once the image loads and we know its size
        setOverlayOpen(true); // Show the overlay and cropper
      };
      reader.readAsDataURL(file);
    }
  };

  // Center a 4:3 crop box sized to 90% of the image once it loads
  const onCropImageLoad = (event) => {
    const { width, height } = event.currentTarget;
    setCrop(
      centerCrop(
        makeAspectCrop({ unit: "%", width: 90 }, 4 / 3, width, height),
        width,
        height
      )
    );
  };

  // react-image-crop's onChange only reports percent units; convert the
  // current crop box to source-image pixel coordinates on demand (rather
  // than relying on onComplete, which doesn't fire for programmatic changes)
  const getCropPixels = () => {
    const img = cropImgRef.current;
    if (!img || !crop) return null;

    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;

    return {
      x: Math.round(((crop.x / 100) * img.width) * scaleX),
      y: Math.round(((crop.y / 100) * img.height) * scaleY),
      width: Math.round(((crop.width / 100) * img.width) * scaleX),
      height: Math.round(((crop.height / 100) * img.height) * scaleY),
    };
  };

  const handleUploadOtherImage = async () => {
    const cropPixels = getCropPixels();
    if (!cropPixels) {
      showError("Please crop the image before uploading.", 8000);
      return;
    }

    setUploading(true);
    setUploadStatus("Preparing image...");

    try {
      const croppedFile = await getCroppedImg(image, cropPixels);

      if (!croppedFile) {
        showError("Cropped file is empty.", 8000);
        return;
      }

      setUploadStatus("Validating photo, please wait...");

      const validationResponse = await ValidatePhotoApi.validatePhoto(
        userId,
        croppedFile,
      );

      if (
        !validationResponse?.status ||
        validationResponse.status !== "success"
      ) {
        const message =
          validationResponse?.data?.reason ||
          validationResponse?.data?.message ||
          "Photo rejected by validator.";

        showError(message, 8000);
        return;
      }

      setUploadStatus("Uploading photo...");

      const compressedFile = await compressImage(croppedFile);

      const uploaded = await uploadAdditionalPhoto(
        compressedFile,
        userId,
        () => {},
        setErrorMessage,
        history,
      );

      if (!uploaded) {
        return;
      }

      showSuccess("Other photo uploaded successfully!", 8000);
      setOverlayOtherOpen(false);
      window.location.href = `/singles/my-profile/${user?.user_id}`;
    } catch (error) {
      console.error(error);
      showError("Failed to process image. Please try again.", 8000);
    } finally {
      setUploading(false);
      setUploadStatus("");
    }
  };

  const handleUploadImage = async () => {
    const cropPixels = getCropPixels();
    if (!cropPixels) {
      showError("Please crop the image before uploading.", 8000);
      return;
    }

    setUploading(true);
    setUploadStatus("Preparing image...");

    try {
      console.log("[UPLOAD] Getting cropped image blob...");
      const croppedFile = await getCroppedImg(image, cropPixels);

      if (!croppedFile) {
        showError("Cropped file is empty.", 8000);
        return;
      }

      setUploadStatus("Validating photo, please wait...");

      const validationResponse = await ValidatePhotoApi.validatePhoto(
        userId,
        croppedFile,
      );

      console.log("[VALIDATION] Raw response:", validationResponse);

      if (
        !validationResponse?.status ||
        validationResponse.status !== "success"
      ) {
        const message =
          validationResponse?.data?.reason ||
          validationResponse?.data?.message ||
          "Photo rejected by validator.";

        showError(message, 8000);
        return;
      }

      setUploadStatus("Uploading photo...");

      const uploaded = await handleImageChange(
        croppedFile,
        userId,
        setErrorMessage,
        () => {},
        history,
      );

      if (!uploaded) {
        return;
      }

      setProfile((prevProfile) => ({
        ...prevProfile,
        profile_image: URL.createObjectURL(croppedFile),
      }));

      showSuccess("Image uploaded successfully!", 8000);
      setOverlayOpen(false);
      notifyProfilePhotoChanged();
      refreshProfileChecklist();
    } catch (error) {
      console.error("[UPLOAD] ❌ Error:", error);
      showError("Failed to process image. Please try again.", 8000);
    } finally {
      setUploading(false);
      setUploadStatus("");
    }
  };

  // Close the overlay without uploading or cropping
  const closeOverlayOther = () => {
    console.log("Closing overlay");
    setOverlayOtherOpen(false);
    setImage(null);
    setCrop(undefined);
  };

  const closeOverlay = () => {
    console.log("Closing overlay");
    setOverlayOpen(false);
    setImage(null);
    setCrop(undefined);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      if (!userId) {
        setError("No user ID provided");
        setLoading(false);
        return;
      }

      const profileData = await ProfileDetails.fetchProfileDetails(userId);
      //   console.log(profileData);
      if (profileData) {
        setProfile(profileData);
      } else {
        setError("Failed to load profile details.");
      }
      setLoading(false);
    };

    fetchProfile();
  }, [userId]);

  const account = profile?.account ?? "N/A";
  const [copied, setCopied] = useState(false);
  //   console.log("profile?.profile_image:", profile?.profile_image);

  // Hidden for admin (1) and Top Level Marketer (4). Affiliate Marketers
  // (5) keep theirs — it's how they onboard clients.
  const shouldShowReferralLink = !["1", "4"].includes(user?.userrole);

  const handleCopy = (value = account) => {
    if (account !== "N/A") {
      navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), AppConstants.TOAST_AUTO_DISMISS_MS);
    }
  };

  // Automatically update aboutMe when profile is loaded
  useEffect(() => {
    if (profile?.aboutMe) {
      setAboutMe(profile.aboutMe);
    }
    if (profile?.photos_hidden === true) {
      setHidePhotos(true);
    }
    if (profile?.show_photos_to_anonymous === true) {
      setShowPhotosToAnonymous(true);
    }
    // Seed the Location dropdowns with the user's saved country. Guarded so
    // it never clobbers a selection the user has already made in this session.
    if (profile?.country_iso_two && !selectedCountry) {
      setSelectedCountry(profile.country_iso_two);
    }
  }, [profile]);

  // Once the region list for the saved country has loaded, match it to the
  // saved area by name (the API only returns the area name, not its id) and
  // pre-select it. Same "don't clobber a manual pick" guard as above.
  useEffect(() => {
    if (selectedRegion || !profile?.area_name || !regions.length) return;

    const savedRegion = regions.find((r) => r.name === profile.area_name);
    if (savedRegion) {
      setSelectedRegion(savedRegion.id);
    }
  }, [regions, profile, selectedRegion]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const openLightbox = (index) => {
    // console.log("Opening lightbox at index:", index);
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % profile.photos.length,
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) =>
        (prevIndex - 1 + profile.photos.length) % profile.photos.length,
    );
  };

  if (loading)
    return <CircularProgress sx={{ display: "block", margin: "50px auto" }} />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Dialog
        open={uploading}
        PaperProps={{ sx: { background: "transparent", boxShadow: "none" } }}
      >
        <Box
          sx={{
            minWidth: 280,
            p: 4,
            bgcolor: "rgba(0,0,0,0.85)",
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress color="inherit" />
          <Typography sx={{ color: "white", textAlign: "center" }}>
            {uploadStatus || "Please wait..."}
          </Typography>
        </Box>
      </Dialog>

      <Box sx={{ flexGrow: 1, width: "100%" }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={4} lg={3}>
            {/* Left pane - profile summary card */}
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
                p: 2,
                mb: { xs: 0, md: 3 }, // stacked on phones: the grid spacing is the gap
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  // Stop the photo growing huge on tablets, where the card is full width
                  maxWidth: { xs: 420, md: "none" },
                  mx: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                }}
              >
                {/* Profile Card */}
                <Card
                  sx={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    borderRadius: "8px",
                    boxShadow: "none",
                    bgcolor: "#f3f4f6",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {profile?.profile_image &&
                  profile.profile_image !== Configs.noPhotoUrl ? (
                    <CardMedia
                      component="img"
                      image={profile.profile_image}
                      alt="Profile"
                      sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <Typography sx={{ fontSize: 16, color: "#999" }}>
                      No photo available
                    </Typography>
                  )}
                </Card>

                {/* Name and country, under the photo */}
                <Box sx={{ mt: 2, textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ textTransform: "none", lineHeight: 1.3 }}
                  >
                    {profile?.name}
                  </Typography>

                  {profile?.country_iso_two && (
                    <Box
                      sx={{
                        mt: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.75,
                        color: "text.secondary",
                      }}
                    >
                      <img
                        src={`${Configs.flagCdnBaseUrl}/${profile.country_iso_two.toLowerCase()}.png`}
                        alt="Country flag"
                        width="20"
                        height="14"
                        style={{ borderRadius: "3px" }}
                      />
                      <Typography variant="body1" sx={{ textTransform: "none" }}>
                        {profile.location.replace(/^, /, "")}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Upload Button and Overlay */}
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<UploadIcon />}
                    sx={{
                      textTransform: "none",
                      color: sweetRed.main,
                      borderColor: sweetRed.main,
                      "&:hover": {
                        borderColor: sweetRed.main,
                        backgroundColor: sweetRed.softBg,
                      },
                    }}
                    onClick={triggerFileInput}
                  >
                    Upload Profile Photo
                  </Button>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1, textAlign: "center" }}
                  >
                    Uploading a new photo replaces the current one.
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      mt: 2,
                      py: 1,
                      textAlign: "center",
                      fontWeight: 500,
                      bgcolor: "#f9fafb",
                      borderRadius: "8px",
                    }}
                  >
                    ⏳ {profile?.subscription_days ?? "N/A"} day(s) left
                  </Typography>

                  {user?.userrole === "3" && (
                    <Button
                      fullWidth
                      size="small"
                      variant="outlined"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        history.push(AppConstants.RENEW_SUBSCRIPTION_PATH)
                      }
                    >
                      Renew subscription
                    </Button>
                  )}

                  {shouldShowReferralLink && (
                    <Box mt={2}>
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        sx={{ mb: 0.5 }}
                      >
                        Referral Link:
                      </Typography>

                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                          p: 1,
                          backgroundColor: "#f7f7f7",
                          borderRadius: "6px",
                          border: "1px solid #ddd",
                          overflow: "hidden",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            mr: 1,
                            wordBreak: "break-all",
                          }}
                        >
                          {`${Configs.domain}/auth/register-page/?ref=${account}`}
                        </Typography>

                        {account !== "N/A" && (
                          <Tooltip
                            title={copied ? "Copied!" : "Copy to clipboard"}
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleCopy(
                                  `${Configs.domain}/auth/register-page/?ref=${account}`,
                                )
                              }
                              color={copied ? "success" : "inherit"}
                            >
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileOtherInputChange}
                    style={{ display: "none" }}
                    ref={fileOtherInputRef}
                  />

                  {overlayOtherOpen && (
                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "90vw",
                          maxWidth: 420,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "100%",
                            mb: 1,
                          }}
                        >
                          <IconButton
                            onClick={closeOverlayOther}
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                              backgroundColor: "rgba(255, 255, 255, 0.6)",
                              color: "white",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                              },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            maxHeight: "60vh",
                            bgcolor: "#111827",
                            borderRadius: 1,
                            overflow: "hidden",
                            p: 1,
                          }}
                        >
                          {image && (
                            <ReactCrop
                              crop={crop}
                              onChange={(_, percentCrop) => setCrop(percentCrop)}
                              aspect={4 / 3}
                            >
                              <img
                                ref={cropImgRef}
                                src={image}
                                onLoad={onCropImageLoad}
                                style={{ maxHeight: "56vh", display: "block" }}
                                alt="Crop preview"
                              />
                            </ReactCrop>
                          )}
                        </Box>

                        <Box sx={{ width: "100%", mt: 2, textAlign: "center" }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "rgba(255, 255, 255, 0.7)", display: "block", mb: 1 }}
                          >
                            Drag the box to move it, or drag a corner/edge to resize.
                          </Typography>
                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                              color: "white",
                              borderColor: "white",
                              "&:hover": {
                                backgroundColor: "transparent",
                                borderColor: "white",
                                color: "white",
                              },
                            }}
                            disabled={!crop}
                            onClick={handleUploadOtherImage}
                          >
                            Upload Cropped Photo
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileInputChange}
                    style={{ display: "none" }}
                    ref={fileInputRef}
                  />

                  {overlayOpen && (
                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "90vw",
                          maxWidth: 420,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "100%",
                            mb: 1,
                          }}
                        >
                          <IconButton
                            onClick={closeOverlay}
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                              backgroundColor: "rgba(255, 255, 255, 0.6)",
                              color: "white",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                              },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            maxHeight: "60vh",
                            bgcolor: "#111827",
                            borderRadius: 1,
                            overflow: "hidden",
                            p: 1,
                          }}
                        >
                          {image && (
                            <ReactCrop
                              crop={crop}
                              onChange={(_, percentCrop) => setCrop(percentCrop)}
                              aspect={4 / 3}
                            >
                              <img
                                ref={cropImgRef}
                                src={image}
                                onLoad={onCropImageLoad}
                                style={{ maxHeight: "56vh", display: "block" }}
                                alt="Crop preview"
                              />
                            </ReactCrop>
                          )}
                        </Box>

                        <Box sx={{ width: "100%", mt: 2, textAlign: "center" }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "rgba(255, 255, 255, 0.7)", display: "block", mb: 1 }}
                          >
                            Drag the box to move it, or drag a corner/edge to resize.
                          </Typography>
                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                              color: "white",
                              borderColor: "white",
                              "&:hover": {
                                backgroundColor: "transparent",
                                borderColor: "white",
                                color: "white",
                              },
                            }}
                            disabled={!crop}
                            onClick={handleUploadImage}
                          >
                            Upload Cropped Image
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  <Snackbar
                    open={Boolean(errorMessage || uploadStatus)}
                    autoHideDuration={6000}
                    message={errorMessage || uploadStatus}
                    onClose={() => {
                      setErrorMessage("");
                      setUploadStatus("");
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Right Pane - Tabs & Content */}
          <Grid item xs={12} md={8} lg={9}>
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
                overflow: "hidden",
                mb: 3,
              }}
            >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  bgcolor: "#fafafa",
                }}
              >
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  orientation={isMobile ? "vertical" : "horizontal"}
                  variant={isMobile ? "fullWidth" : "standard"}
                  textColor="inherit"
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: sweetRed.main,
                    },
                  }}
                  sx={{
                    borderRight: isMobile ? 1 : 0,
                    borderColor: "divider",
                  }}
                >
                  <Tab
                    label="My Gallery Photos"
                    sx={{
                      width: isMobile ? "100%" : "auto",
                      alignItems: isMobile ? "flex-start" : "center",
                      textAlign: isMobile ? "left" : "center",
                      justifyContent: "flex-start",
                      mr: isMobile ? 0 : 2,
                      px: isMobile ? 2 : 3,
                      borderBottom: isMobile ? "1px solid #e0e0e0" : "none",
                      color: activeTab === 0 ? sweetRed.hover : sweetRed.main,
                      fontWeight: activeTab === 0 ? "bold" : "normal",
                    }}
                  />

                  <Tab
                    label="About Me"
                    sx={{
                      width: isMobile ? "100%" : "auto",
                      alignItems: isMobile ? "flex-start" : "center",
                      textAlign: isMobile ? "left" : "center",
                      justifyContent: "flex-start",
                      mr: isMobile ? 0 : 2,
                      px: isMobile ? 2 : 3,
                      borderBottom: isMobile ? "1px solid #e0e0e0" : "none",
                      color: activeTab === 1 ? sweetRed.hover : sweetRed.main,
                      fontWeight: activeTab === 1 ? "bold" : "normal",
                    }}
                  />

                  <Tab
                    label="Settings"
                    sx={{
                      width: isMobile ? "100%" : "auto",
                      alignItems: isMobile ? "flex-start" : "center",
                      textAlign: isMobile ? "left" : "center",
                      justifyContent: "flex-start",
                      mr: isMobile ? 0 : 2,
                      px: isMobile ? 2 : 3,
                      color: activeTab === 2 ? sweetRed.hover : sweetRed.main,
                      fontWeight: activeTab === 2 ? "bold" : "normal",
                    }}
                  />
                </Tabs>
              </Box>

              {/* Tab Content */}
              <Box p={2}>
                {activeTab === 0 && (
                  <MyPhotosTab
                    profile={profile}
                    openLightbox={openLightbox}
                    triggerOtherFileInput={triggerOtherFileInput}
                    onProfilePhotoChanged={handleProfilePhotoChanged}
                  />
                )}

                {activeTab === 1 && (
                  <AdditionalInfoTab
                    sweetRed={sweetRed}
                    aboutMe={aboutMe}
                    setAboutMe={setAboutMe}
                    wordCount={wordCount}
                    handleSaveAboutMe={handleSaveAboutMe}
                    preferenceCategories={preferenceCategories}
                    selectedPrefs={selectedPrefs}
                    setSelectedPrefs={setSelectedPrefs}
                    profile={profile}
                    countries={countries}
                    regions={regions}
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                    selectedRegion={selectedRegion}
                    setSelectedRegion={setSelectedRegion} // ✅ ADD THIS
                    handleRegionChange={handleRegionChange}
                  />
                )}

                {activeTab === 2 && (
                  <SettingsTab
                    sweetRed={sweetRed}
                    profile={profile}
                    user={user}
                    sendMessage={sendMessage}
                    isConnected={isConnected}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Lightbox */}
      {lightboxOpen && (
        <PhotoLightbox
          open={lightboxOpen}
          photos={profile.photos}
          currentIndex={currentImageIndex}
          onClose={closeLightbox}
          onNext={nextImage}
          onPrev={prevImage}
        />
      )}
    </Box>
  );
};

export default MyProfile;
